// * Bootstrap libraries
import './_bootstrap';

// * Any other global site-wide JavaScript should be placed below.
import { initCookieConsentLink } from "./cookie-consent-link";
import { initCookieConsentFocus } from "./cookie-consent-focus";
import { initSkipLinkFocus } from "./skip-link-focus";

initCookieConsentLink(Drupal);
initCookieConsentFocus(Drupal);
initSkipLinkFocus(Drupal);
